<template>
  <NuxtLink
    :to="localePath({ name: 'dashboard', params: { dashboard: dashboardMode } })"
    :class="navigationClasses"
    :exact-active-class="navigationActiveClasses"
   
  >
    {{ t('pageLink.dashboard') }}
    <div
      v-if="dashboardNotificationsTotal"
      :class="notificationClasses"
    >{{ dashboardNotificationsTotal }}</div>
  </NuxtLink>

  <NuxtLink
    :to="localePath({ name: 'dashboard-calendar', params: { dashboard: dashboardMode } })"
    :class="navigationClasses"
    :exact-active-class="navigationActiveClasses"
  >
    {{ t('pageLink.calendar') }}
  </NuxtLink>

  <NuxtLink
    :to="localePath({ name: 'dashboard-messages', params: { dashboard: dashboardMode } })"
    :class="navigationClasses"
    :exact-active-class="navigationActiveClasses"
   
  >
    {{ t('pageLink.inbox') }}
    <div
      v-if="inboxNotificationsTotal"
      :class="notificationClasses"
    >{{ inboxNotificationsTotal }}</div>
  </NuxtLink>

  <NuxtLink
    :to="localePath({ name: 'dashboard-insights', params: { dashboard: dashboardMode } })"
    :class="navigationClasses"
    :active-class="navigationActiveClasses"
   
  >
    {{ t('pageLink.insights') }}
    <div
      v-if="opportunitiesNotificationsGrouped || isSuspended"
      :class="notificationClasses"
    >{{ isSuspended ? 1 : opportunitiesNotificationsGrouped }}</div>
  </NuxtLink>

  <NuxtLink
    :to="localePath({ name: 'dashboard-rvs', params: { dashboard: dashboardMode } })"
    :class="[navigationClasses]"
    :active-class="navigationActiveClasses"
   
  >
    {{ t('pageLink.myListings') }}
  </NuxtLink>
</template>

<script lang="ts" setup>
const { t } = useI18n()
const localePath = useLocalePath()
const { dashboardMode } = useBaseName()

const {
  dashboardNotificationsTotal,
  inboxNotificationsTotal,
  isSuspended,
  opportunitiesNotificationsGrouped,
} = useNotificationsData()

const navigationClasses = computed(() => 'relative text-sm/6 xl:text-base/6 font-semibold text-gray-500 hover:text-primary-950')
const navigationActiveClasses = computed(() => 'text-primary-950 relative before:content-[\'\'] before:absolute before:mt-full before:-bottom-7 before:left-0 before:right-0 before:h-0.5 before:bg-primary-500')

const notificationClasses = computed(() => 'inline-flex items-center justify-center min-w-4 h-4 px-1.5 bg-secondary rounded-full text-white text-[10px] absolute top-0 right-0 -translate-y-2/3 translate-x-2/3')
</script>
